import { useEffect } from "react";
import { useAnalyticsOnClick } from "../../hooks/card-hooks";
import { event } from "../../../../analytics";
import { getPhoneNumber } from "../../../../utils/app-utils";

const getDescriptionText = description =>
  (description && description) || "dropout_card-text_1";

export const useJourneyAbnormallyContent = ({
  type,
  config,
  description,
  eventName
}) => {
  useEffect(() => {
    if (eventName) {
      event(eventName, "current_notification");
    }
  });

  const onCallClicked = useAnalyticsOnClick({
    eventName: "call"
  });

  const phoneNumber = getPhoneNumber({ type, config });
  const descriptionText = getDescriptionText(description);

  return { phoneNumber, descriptionText, onCallClicked };
};

export default useJourneyAbnormallyContent;
